import React, {FC, useEffect, useState} from "react";
import GatewayService from "../../service/GatewayService";
import {CheckboxComponent} from "../util/CheckboxComponent";
import AppConstants from "../../util/AppConstants";
import AppUtil from "../../util/AppUtil";
import {SqueezeSell} from "../../models/Squeeze";
import CollectionUtils from "../../util/CollectionUtils";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import {PlacedCombo} from "../../models/PlacedCombo";
import MarginsComponent from "../MarginsComponent";
import { useChain } from "../../context/ChainContext";
import 'react-calendar/dist/Calendar.css';
import '../Calendar.css';
import {TimeUtil} from "../../util/TimeUtil";
import {Combo} from "../../models/Combo";
import {toast} from "react-hot-toast";
import {FCStatus} from "../../models/FCStatus";
import {useClients} from "../../context/ClientsContext";

interface Props {
}
function Head(props : {setSorter:any, showCanSell:boolean, group: boolean}) {
    const setSorter = props.setSorter;
    return <thead>
    <tr>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("time"))}>time</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("clientId"))}>clientId</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("name"))}>name</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("symbols"))}>symbols</th>
        {props.showCanSell && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("canSell"))}>canSell</th>}
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("type"))}>type</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("qty"))}>qty</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("boughtAt"))}>boughtAt</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("soldAt"))}>soldAt</th>
        {props.group && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("buys"))}>buys</th>}
        {props.group && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("sells"))}>sells</th>}
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("premiumReceived"))}>premiumReceived</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("taxes"))}>taxes</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("days"))}>days</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("margin"))}>margin</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("capital"))}>capital</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("profit"))}>profit</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("interest"))}>interest</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("netProfit"))}>netProfit</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("includingBonus"))}>bonus</th>
        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("turnOver"))}>turnOver</th>
    </tr>
    </thead>
}

const DateRangePresets = ({ setFrom, setTo }: { setFrom: (d: Date) => void, setTo: (d: Date) => void }) => {
    const setToday = () => {
        const start = new Date(); start.setHours(0, 0, 0, 0);
        const end = new Date(); end.setHours(23, 59, 59, 999);
        setFrom(start); setTo(end);
    };

    const setYesterday = () => {
        const yesterdayStart = new Date(); yesterdayStart.setDate(yesterdayStart.getDate() - 1); yesterdayStart.setHours(0, 0, 0, 0);
        const yesterdayEnd = new Date(); yesterdayEnd.setDate(yesterdayEnd.getDate() - 1); yesterdayEnd.setHours(23, 59, 59, 999);
        setFrom(yesterdayStart); setTo(yesterdayEnd);
    };

    const setThisWeek = () => {
        const today = new Date();
        const dayOfWeek = today.getDay();
        const start = new Date(today);
        start.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1)); // Monday as start of week
        start.setHours(0, 0, 0, 0);
        const end = new Date(); end.setHours(23, 59, 59, 999);
        setFrom(start); setTo(end);
    };

    const setThisMonth = () => {
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        start.setHours(0, 0, 0, 0);
        const end = new Date(); end.setHours(23, 59, 59, 999);
        setFrom(start); setTo(end);
    };

    const setSinceBeginning = () => {
        const start = new Date(0);
        const end = new Date(); end.setHours(23, 59, 59, 999);
        setFrom(start); setTo(end);
    };

    return (
        <div className="date-presets" style={{display: 'inline-flex', gap: '5px', marginLeft: '10px'}}>
            <button onClick={setToday}>Today</button>
            <button onClick={setYesterday}>Yesterday</button>
            <button onClick={setThisWeek}>This Week</button>
            <button onClick={setThisMonth}>This Month</button>
            <button onClick={setSinceBeginning}>Since Beginning</button>
        </div>
    );
};

const ComboOrderaComp: FC<Props> = (props) => {

    const { chain, setChain } = useChain();
    const [placedOrders, setPlacedOrders] = useState<Array<PlacedCombo>>([]);
    const [from, setFrom] = useState<Date>(() => { const d = new Date(); d.setHours(0,0,0,0); return d; });
    const [to, setTo] = useState<Date>(() => { const d = new Date(); d.setHours(23,59,59,999); return d; });
    const [type, setType] = useState("")
    const [lag, setLag] = useState(-1)
    const [orderCallBackTime, setCallbackTime] = useState(-1)
    const [analyse, setAnalyse] = useState(false)
    const [group, setGroup] = useState(false)
    const [canExec, setCanExec] = useState(false)
    const [showExpired, setShowExpired] = useState(false)
    const [cutoffMargin, setCutoffMargin] = useState(-1)
    const [client, setClient] = useState("")
    const [clients, setClients] = useState<string[]>([])
    // const { clients } = useClients();

    const [mcxClient, setMcxClient] = useState<string>()
    const [mcxMasterTrustClient, setMcxMasterTrustClient] = useState<string>()
    const [sorter, setSorter] = useState(() => AppUtil.genericSorterFun("squeeze", (a: SqueezeSell) => 1))
    const [showMargins, setShowMargins] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdatingCutoff, setIsUpdatingCutoff] = useState(false);
    const [fcStatus, setFcStatus] = useState<FCStatus | null>(null);

    const clients2 = [...clients, "RHN1310_U", "RHN536_U", "RHN1309_U"]
    useEffect(() => {
        refresh()
    }, [props, from, to, group, showExpired, analyse, type, client])

    function refreshClients() {
        GatewayService.getClients().then(res => {
            setClients(res.clients)
            setMcxClient(res.mcxClient)
            setMcxMasterTrustClient(res.mcxMasterClient)
        })
    }

    function fetchCutoffMargin() {
        GatewayService.getCutoffMargin().then((res: {second: number}) => {
            setCutoffMargin(res.second / 100000) // Convert from base units to lakhs
        })
    }

    function updateCutoffMargin(cutOffInLacks: number) {
        setCutoffMargin(-100)
        setIsUpdatingCutoff(true);
        GatewayService.updateCutoffMargin(cutOffInLacks).then((res: {second: number}) => {
            setCutoffMargin(res.second / 100000) // Convert from base units to lakhs
        }).finally(() => {
            setIsUpdatingCutoff(false);
        })
    }

    function getChurnerOrderStatus(){
        GatewayService.getChurnerOrderStatus().then(it => toast(it.toString()))
    }
    function refresh() {
        setIsLoading(true);
        GatewayService.canExec().then(a => setCanExec(a.second));
        GatewayService.getChurnerStatus().then(setFcStatus);

        GatewayService.getComboOrders({
            clientId: client,
            chain: chain,
            from: from?.getTime(),
            to: to?.getTime(),
            group: group,
            analyse: analyse,
            nonExpired: showExpired,
        })
            .then(it => it.sort((b, a) => b.time - a.time))
            .then(setPlacedOrders)
            .catch(err => {
                console.error("Failed to fetch combo orders", err);
                setPlacedOrders([]);
            })
            .finally(() => setIsLoading(false));

        refreshClients()
        fetchCutoffMargin()
    }

    function getItems() {
        return placedOrders
            .filter(it => type === "" || type === it.type)
            .sort(sorter)
    }

    let rows = getItems()
    let interests = CollectionUtils.sumOf(rows, "interest")/100000;
    let taxes = CollectionUtils.sumOf(rows, "tax", "lot");
    let days = 0
    rows.forEach(it => {
        days+=(it.days*it.capital)
    })
    days/=CollectionUtils.sumOf(rows, "capital")

    function setAllowed(allowed: boolean) {
        GatewayService.setAllowed(allowed).then(a=>refresh())
    }

    function checkLag() {
        GatewayService.checkStatus(mcxClient!!).then(a=> {
          setCallbackTime(a.orderCallBackTime)
          setLag(a.feedLag)
        })
    }

    function setMCXClient(client:string){
        GatewayService.setMcxClient(client).then(a=>refreshClients())
    }

    function setMCXMaster(client:string){
        GatewayService.setMCXMaster(client).then(a=>refreshClients())
    }

    function exportCombosCSV() {
        if (!rows.length) return;
        const headers = [
            "type", "time", "name", "clientId", "symbols", "lot", "days", "tax", "boughtAt", "soldAt", "premiumReceived", "margin", "profit", "capital", "interest", "netProfit", "turnOver", "includingBonus", "canSell"
        ];
        const csvRows = [headers.join(",")];
        rows.forEach(row => {
            const values = [
                row.type,
                AppUtil.getDate(row.time),
                row.name,
                row.clientId,
                '"' + row.symbols.replace(/"/g, '""') + '"',
                row.lot,
                row.days,
                row.tax,
                row.boughtAt,
                row.soldAt,
                row.premiumReceived,
                row.margin,
                row.profit,
                row.capital,
                row.interest,
                row.netProfit,
                row.turnOver,
                row.includingBonus,
                row.canSell ? '"' + row.canSell.join(';').replace(/"/g, '""') + '"' : ''
            ];
            csvRows.push(values.join(","));
        });
        const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "combo_orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function addRemark(combo: PlacedCombo) {
        const remark = prompt("Enter remarks:", combo.remarks ?? "");
        if (remark !== null) {
            GatewayService.addRemark(combo.id, remark).then(refresh);
        }
    }

    function handleChurnerUpdate(update: Partial<FCStatus>) {
        GatewayService.updateChurnerStatus(update).then(setFcStatus);
    }


    // Determine if any row has a non-empty canSell value
    const showCanSell = rows.some(it => it.canSell && it.canSell.length > 0);

    if (isLoading || isUpdatingCutoff) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <div className="loading-text">
                    {isUpdatingCutoff ? "Updating cut-off margin..." : "Loading orders..."}
                </div>
            </div>
        );
    }
    let summary = <tr>
        <td>time</td>
        <td>client</td>
        <td>NAME</td>
        <td>{rows.map(it=> it.orders.length).reduce((a,b)=> a+b, 0)}</td>
        {showCanSell && <td>canSell</td>}
        {showCanSell && <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "potentialValue"))}</td>}
        <td>type</td>
        <td>lot</td>
        <td>bought</td>
        <td>sold</td>
        {group && <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "buys")/100000)}L</td>}
        {group && <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "sells")/100000)}L</td>}
        <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "premiumReceived", "lot")/100000)}L</td>
        <td>{AppUtil.getRoundedOff(taxes)}</td>
        <td>{AppUtil.getRoundedOff(days)}</td>
        <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "margin")/100000)}L</td>
        <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "capital")/100000)}L</td>
        <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "profit")/100000)}L</td>
        <td>{AppUtil.getRoundedOff(interests)}L</td>
        <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "netProfit")/100000)}L</td>
        <td>{AppUtil.getRoundedOff((CollectionUtils.sumOf(rows, "includingBonus"))/100000)}L</td>
        <td>{AppUtil.getRoundedOff(CollectionUtils.sumOf(rows, "turnOver")/100000)}L</td>
    </tr>
    let showRed = !fcStatus?.execute || !fcStatus.confidenceGained;
    return <>
        <div className={canExec ? "comboorders-controls" : "comboorders-controls red"}>
            <button onClick={() => setShowMargins(v => !v)}>
                {showMargins ? "Hide Margins" : "View Margins"}
            </button>
            <input placeholder="chain" type="text" value={chain} onChange={event => setChain(event.target.value)}/>
            <button onClick={() => refresh()}>refresh</button>
            <button onClick={exportCombosCSV}>Export CSV</button>
            <DropDownCompString text={"type"} actual={type} arr={getKeyVal(AppConstants.comboTypes)} set={setType}/>
            <div className="control-group">
                <label>From: <input type="date" value={TimeUtil.toYYYYMMDD(from)} onChange={e => {
                    const d = TimeUtil.fromYYYYMMDD(e.target.value);
                    d.setHours(0,0,0,0);
                    setFrom(d);
                }}/></label>
                <label>To: <input type="date" value={TimeUtil.toYYYYMMDD(to)} onChange={e => {
                    const d = TimeUtil.fromYYYYMMDD(e.target.value);
                    d.setHours(23,59,59,999);
                    setTo(d);
                }}/></label>
                <DateRangePresets setFrom={setFrom} setTo={setTo} />
            </div>
            <CheckboxComponent text={"analyse"} actual={analyse} val={analyse} set={setAnalyse}/>
            <CheckboxComponent text={"group"} actual={group} val={group} set={setGroup}/>
            <CheckboxComponent text={"show expired"} actual={showExpired} val={showExpired} set={setShowExpired}/>
            <DropDownCompString text={"client"} actual={client} arr={getKeyVal(AppConstants.CLIENTS)} set={setClient}/>
            <DropDownCompString text={"currentClient"} actual={mcxClient!!} arr={getKeyVal(clients!!)} set={setMCXClient}/>
            <DropDownCompString text={"master trust client"} actual={mcxMasterTrustClient!!} arr={getKeyVal(clients!!)} set={setMCXMaster}/>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <label>Cut-off margin (L):</label>
                <input 
                    type="number" 
                    value={cutoffMargin} 
                    onChange={e => setCutoffMargin(Number(e.target.value))}
                    style={{width: '80px'}}
                />
                <button onClick={() => updateCutoffMargin(cutoffMargin)}>Update</button>
            </div>
        </div>
        {fcStatus && clients && (
            <div className="churner-status-controls">
                <span>Churner:- </span>
                <span>can exec: <b>{fcStatus.execute?.toString()}</b></span>
                <button onClick={() => handleChurnerUpdate({ execute: !fcStatus.execute })}>Toggle Exec</button>
                <span>confidence: <b>{fcStatus.confidenceGained?.toString()}</b></span>
                <button onClick={() => getChurnerOrderStatus()}>Order status</button>
                <button onClick={() => handleChurnerUpdate({ confidenceGained: !fcStatus.confidenceGained })}>Toggle Confidence</button>
                <DropDownCompString text={"expiry"} actual={fcStatus.expiryClient || ""} arr={getKeyVal(clients2)} set={val => handleChurnerUpdate({ expiryClient: val })} />
                <DropDownCompString text={"near"} actual={fcStatus.nearClient || ""} arr={getKeyVal(clients2)} set={val => handleChurnerUpdate({ nearClient: val })} />
                <DropDownCompString text={"far"} actual={fcStatus.farClient || ""} arr={getKeyVal(clients2)} set={val => handleChurnerUpdate({ farClient: val })} />
            </div>
        )}
        {showMargins && <MarginsComponent />}
        <div className="comboorders-status-bar">
            <span>Options:- </span>
            <span>mcx client: <b>{mcxClient}</b></span>
            <span>can exec: <b className={!canExec ? "red" : ""}>{canExec+""}</b></span>
            <button onClick={()=>setAllowed(true)}>allow</button>
            <button onClick={()=>setAllowed(false)}>STOP</button>
            <button onClick={()=>checkLag()}>check lag</button>
            <span>({lag}) - ({orderCallBackTime})</span>
        </div>
        {rows.length === 0 ? (
            <div className="comboorders-no-orders">No orders</div>
        ) : (
            <div className="comboorders-table-container">
                <table className={showRed ? "red" : ""}>
                    <thead>
                    <tr>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("time"))}>time</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("clientId"))}>clientId</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("name"))}>name</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("symbols"))}>symbols</th>
                        {showCanSell && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("canSell"))}>canSell</th>}
                        {showCanSell && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("potentialValue"))}>potentialValue</th>}
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("type"))}>type</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("qty"))}>qty</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("boughtAt"))}>boughtAt</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("soldAt"))}>soldAt</th>
                        {group && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("buys"))}>buys</th>}
                        {group && <th onClick={() => setSorter(AppUtil.genericSorterWrapper("sells"))}>sells</th>}
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("premiumReceived"))}>premiumReceived</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("taxes"))}>taxes</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("days"))}>days</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("margin"))}>margin</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("capital"))}>capital</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("profit"))}>profit</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("interest"))}>interest</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("netProfit"))}>netProfit</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("includingBonus"))}>bonus</th>
                        <th onClick={() => setSorter(AppUtil.genericSorterWrapper("turnOver"))}>turnOver</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows.length > 0 && summary}
                    {rows.map(it => {
                        let time = new Date(it.time)
                        const tooltip = it.orders.map(o => `${o.tradingSymbol} (${o.isBuy ? 'bought' : 'sold'}) - ${o.bidAskPrice ?? ''} - ${o.price}`).join('\n');
                        return <tr>
                            <td>{from.toDateString() === to.toDateString() ? time.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : time.toLocaleString()}</td>
                            <td>{it.clientId}</td>
                            <td
                                title={tooltip}
                                onDoubleClick={() => {
                                    navigator.clipboard.writeText(tooltip);
                                    toast.success("Copied to clipboard");
                                }}
                            >{it.name}</td>
                            <td className="symbols-cell" title={it.symbols}>{it.symbols}</td>
                            {showCanSell && <td>
                                {it.canSell.join(",")}
                                <button
                                    style={it.remarks ? {color: "red", fontWeight: "bold"} : {}}
                                    title={it.remarks ?? ""}
                                    onClick={() => addRemark(it)}>Add Remark</button>
                            </td>}
                            {showCanSell && <td>{it.potentialValue}</td>}
                            <td>{it.type}</td>
                            <td>{it.lot}</td>
                            <td>{it.boughtAt}</td>
                            <td>{it.soldAt}</td>
                            {group && <td>{AppUtil.getRoundedOff(it.buys/100000)}L</td>}
                            {group && <td>{AppUtil.getRoundedOff(it.sells/100000)}L</td>}
                            <td>{AppUtil.getRoundedOff(it.premiumReceived * it.lot)}</td>
                            <td>{AppUtil.getRoundedOff(it.tax * it.lot)}</td>
                            <td>{AppUtil.getRoundedOff(it.days)}</td>
                            <td>{AppUtil.getRoundedOff(it.margin)}</td>
                            <td>{AppUtil.getRoundedOff(it.capital)}</td>
                            <td style={{fontWeight : "bold"}}>{AppUtil.getRoundedOff(it.profit/(group? 100000 : 1)) + (group? "L" : "1")}</td>
                            <td>{AppUtil.getRoundedOff(it.interest)}</td>
                            <td>{AppUtil.getRoundedOff(it.netProfit)}</td>
                            <td style={{fontWeight : "bold"}}>{AppUtil.getRoundedOff(it.includingBonus/(group? 100000 : 1)) + (group? "L" : "1")}</td>
                            {/*<td>{AppUtil.getRoundedOff(it.includingBonus)}</td>*/}
                            <td>{AppUtil.getRoundedOff(it.turnOver)}</td>
                        </tr>
                    }
                    )}
                    {summary}
                    </tbody>
                    <Head setSorter={setSorter} showCanSell={showCanSell} group={group}/>
                </table>
            </div>
        )}
    </>
}

export default ComboOrderaComp
